import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { UserSummary } from "@shared/models/user"
import ObjectId from "@shared/util/object-id-gen"

interface Signature {
  Element: any
  Args: {
    userSummaries: UserSummary[]
    avatarSizeClass:
      | "user-avatar--xxl"
      | "user-avatar--lg"
      | "user-avatar--md"
      | "user-avatar--sm"
      | "user-avatar--xs"
    enableTooltip?: boolean
  }
  Blocks: {
    default?: any
  }
}

export default class MoreUserAvatars extends Component<Signature> {
  @service basicTooltip

  @tracked elementId
  @tracked showTooltip = false

  constructor(owner, args) {
    super(owner, args)
    this.elementId = `guid-${ObjectId.create()}`
  }

  get cssClasses() {
    return `user-avatar ${this.args.avatarSizeClass}`
  }

  get tooltipText() {
    return this.args.userSummaries
      .map(
        (userSummary) => `${userSummary.attributes.firstName} ${userSummary.attributes.lastName}`
      )
      .join(", ")
  }

  @action onMouseEnter() {
    if (this.args.enableTooltip) {
      this.basicTooltip.show({
        targetId: this.elementId,
        message: this.tooltipText,
      })
    }
  }

  @action onMouseLeave() {
    if (this.args.enableTooltip) {
      this.basicTooltip.hide({ targetId: this.elementId })
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "User::MoreAvatars": typeof MoreUserAvatars
  }
}
